module.exports = __webpack_public_path__ + "img/message-question-circle.81d5be1c.svg";